import React from "react";
import { useStyles } from "./style";
import { LinksProps } from "./types";
import { Accordion } from "../accordion/accordion";
import useWindowSize from "../../hooks/change-size";

const Mobile = ({ data }: { data: LinksProps }) => {
  const classes = useStyles();
  return (
      <section className={classes.linksContainer}>
        {data.map((el, idx) => (
            <Accordion
                title={<div className={classes.linksColumnTitle}>{el.title}</div>}
                key={idx}
                body={
                  <ul className={classes.linksColumnItems}>
                    {el.elements.map((el) => (
                        <li key={el.text} className={classes.linksColumnItem}>
                          <a className={classes.linksColumnLink} href={el.href}  aria-label={el.text} target={el.target ? el.target : '_self'}>
                            {el.text}
                          </a>
                        </li>
                    ))}
                  </ul>
                }
            />
        ))}
      </section>
  );
};

const NotMobile = ({ data }: { data: LinksProps }) => {
  const classes = useStyles();
  return (
      <section className={"linksHelper " + classes.linksContainer}>
        {data.map((el, idx) => (
            <div className={classes.linksColumn} key={idx}>
              <div className={classes.linksColumnTitle}>{el.title}</div>
              <ul className={classes.linksColumnItems}>
                {el.elements.map((el) => (
                    <li key={el.text} className={classes.linksColumnItem}>
                      <a className={classes.linksColumnLink} href={el.href} aria-label={el.text} target={el.target ? el.target : '_self'}>
                        {el.text}
                      </a>
                    </li>
                ))}
              </ul>
            </div>
        ))}
      </section>
  );
};

export const Links = ({ data }: { data: LinksProps }) => {
  const size = useWindowSize();
  const mobile = size.width <= 600;
  return mobile ? <Mobile data={data} /> : <NotMobile data={data} />;
};
